import { useSearchParams } from 'react-router-dom';

import { FORM_ID } from 'constants/form-ids';
import { SEARCH_PARAMS } from 'constants/search-params';
import { PAGE_CONFIG } from 'pages/page-config';
import { LoadDataContainer } from 'views/app/load-data-container';
import { CheckView } from 'views/components/base/check-view';

const CheckViewPage = () => {
  const [searchParams] = useSearchParams();
  const formId = searchParams.get(SEARCH_PARAMS.CUSTOM_FORM) || '';
  const formKey = FORM_ID[formId] || 'default';

  const { ViewCheck } = PAGE_CONFIG[formKey];

  return (
    <LoadDataContainer formKey={formKey} withoutLayout>
      {ViewCheck ? <ViewCheck /> : <CheckView />}
    </LoadDataContainer>
  );
};

export default CheckViewPage;
